import * as urlUtils from 'utils/Url';


export function getPathAovProgressBarOverview(qs={}) {
  return urlUtils.appendQueryString(`/aov-progress-bar-overview`, qs);
}

export function getPathAovProgressBarConnections(qs={}) {
  return urlUtils.appendQueryString(`/aov-progress-bar-connections`, qs);
}

export function getPathAddAovProgressBar() {
  return `/aov-progress-bars/add`;
}

export function getPathEditAovProgressBar(apbId) {
  return `/aov-progress-bars/${apbId}/edit`;
}

export function getPathReplicateAovProgressBar(apbId) {
  return `/aov-progress-bars/${apbId}/replicate`;
}

